"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.svgIconFileLimit = exports.stepNoteResourceAllowed = exports.resourceAllowed = exports.removeSvgColors = exports.isVideoUrl = exports.isVideoType = exports.isSupportedFileType = exports.isImageUrl = exports.isImageType = exports.isGif = exports.isAllowedSize = exports.isAllowedResourceType = exports.imageTypes = exports.getUploadPresetForFile = exports.getThumbnail = exports.getResourceType = exports.getInnerWidth = exports.getIdFromCloudinaryVideoUrl = exports.getFixedExtensionFromUrl = exports.getFilenameAndTransformationsFromCloudinaryUrl = exports.getFileTypes = exports.getExtensionFromUrl = exports.getCloudinaryVideoUrl = exports.getCloudinaryImageUrl = exports.getAllowedSizeForResource = exports.generateOptionString = exports.convertBToMb = exports.acceptedFileTypes = void 0;
var _cloudinaryUtils = require("./cloudinary-utils");
var _genericUtils = require("./generic-utils");
var _config = _interopRequireDefault(require("../config"));
var _mediaConfig = require("../media-config");
var _map = _interopRequireDefault(require("lodash/map"));
var _forEach = _interopRequireDefault(require("lodash/forEach"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var svgIconFileLimit = exports.svgIconFileLimit = 95 * 1024;
var getFileTypes = exports.getFileTypes = function getFileTypes(config) {
  return config.types.map(function (extension) {
    return "".concat(config.type, "/").concat(extension);
  });
};
var videoTypes = getFileTypes(_mediaConfig.VIDEO_CONFIG);
var imageTypes = exports.imageTypes = getFileTypes(_mediaConfig.IMAGE_CONFIG);
var acceptedFileTypes = exports.acceptedFileTypes = [].concat(_toConsumableArray(videoTypes), _toConsumableArray(imageTypes));
var getResourceType = exports.getResourceType = function getResourceType(file) {
  var _file$type$split = file.type.split('/'),
    _file$type$split2 = _slicedToArray(_file$type$split, 1),
    type = _file$type$split2[0];
  return type;
};
var isAllowedResourceType = exports.isAllowedResourceType = function isAllowedResourceType(type) {
  return type === 'video' || type === 'image';
};
var convertBToMb = exports.convertBToMb = function convertBToMb(b) {
  return b / 1000000;
};
var getAllowedSizeForResource = exports.getAllowedSizeForResource = function getAllowedSizeForResource(resourceType) {
  return resourceType === 'video' ? _mediaConfig.VIDEO_CONFIG.mbLimit : _mediaConfig.IMAGE_CONFIG.mblimit;
};
var isAllowedSize = exports.isAllowedSize = function isAllowedSize(file, resourceType) {
  var fileLimitInMb = getAllowedSizeForResource(resourceType);
  var _file$size = file.size,
    size = _file$size === void 0 ? 0 : _file$size;
  var fileSizeInMb = convertBToMb(size);
  return fileSizeInMb < fileLimitInMb;
};
var getUploadPresetForFile = exports.getUploadPresetForFile = function getUploadPresetForFile(file) {
  var resourceType = getResourceType(file);
  return resourceType === 'video' ? _mediaConfig.VIDEO_CONFIG.uploadPreset : _mediaConfig.IMAGE_CONFIG.uploadPreset;
};
var isSupportedFileType = exports.isSupportedFileType = function isSupportedFileType(file, resourceType, allowedFileTypes) {
  var supportedFileTypes = allowedFileTypes || (resourceType === 'video' ? videoTypes : imageTypes);
  return supportedFileTypes.indexOf(file.type) !== -1;
};
var getExtensionFromUrl = exports.getExtensionFromUrl = function getExtensionFromUrl(url) {
  url = url || '';
  if (url) {
    var splitted = url.split('.');
    return splitted[splitted.length - 1];
  }
  return '';
};
var getFixedExtensionFromUrl = exports.getFixedExtensionFromUrl = function getFixedExtensionFromUrl(url) {
  var extension = getExtensionFromUrl(url);
  if (_mediaConfig.DIRTY_VIDEO_EXTENSIONS.indexOf(extension) !== -1) {
    return 'mp4';
  }
  return extension;
};
var isVideoUrl = exports.isVideoUrl = function isVideoUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return Boolean(url) && url.indexOf('/video/upload/') !== -1;
};
var isImageUrl = exports.isImageUrl = function isImageUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return Boolean(url) && _mediaConfig.IMAGE_CONFIG.types.indexOf(getExtensionFromUrl(url)) !== -1;
};
var isVideoType = exports.isVideoType = function isVideoType() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return Boolean(type) && videoTypes.indexOf(type) !== -1;
};
var isImageType = exports.isImageType = function isImageType() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return Boolean(type) && imageTypes.indexOf(type) !== -1;
};
var getThumbnail = exports.getThumbnail = function getThumbnail(url) {
  var returnPlaceholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var fullVideo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  url = url || '';
  if (!(0, _genericUtils.stringHasValue)(url)) {
    return returnPlaceholder ? _config["default"].placeholderImageUrl : null;
  }
  if (isVideoUrl(url)) {
    return getCloudinaryVideoUrl(url, fullVideo ? getExtensionFromUrl(url) : 'jpg', options);
  }
  return getCloudinaryImageUrl(url, options);
};
var resourceAllowed = exports.resourceAllowed = function resourceAllowed(file, allowVideos, allowedFileTypes) {
  var resourceType = getResourceType(file);
  var allowedSize = getAllowedSizeForResource(resourceType);
  if (resourceType === 'video' && allowVideos === false) {
    return {
      allowed: false,
      error: {
        type: 'videosForbidden'
      }
    };
  }
  if (!isAllowedResourceType(resourceType)) {
    return {
      allowed: false,
      error: {
        type: 'typeForbidden'
      }
    };
  }
  if (!isSupportedFileType(file, resourceType, allowedFileTypes)) {
    return {
      allowed: false,
      error: {
        type: 'extensionForbidden'
      }
    };
  }
  if (!isAllowedSize(file, resourceType)) {
    return {
      allowed: false,
      error: {
        type: 'tooLarge',
        data: {
          allowedSize: allowedSize
        }
      }
    };
  }
  return {
    allowed: true
  };
};
var stepNoteResourceAllowed = exports.stepNoteResourceAllowed = function stepNoteResourceAllowed(file) {
  var LIMIT_SIZE = svgIconFileLimit;
  if (!file.type.includes('image/svg')) {
    return {
      allowed: false,
      error: {
        type: 'extensionForbidden'
      }
    };
  }
  if (LIMIT_SIZE < file.size) {
    return {
      allowed: false,
      error: {
        type: 'tooLarge',
        data: {
          allowedSize: LIMIT_SIZE
        }
      }
    };
  }
  return {
    allowed: true
  };
};
var getFilenameAndTransformationsFromCloudinaryUrl = exports.getFilenameAndTransformationsFromCloudinaryUrl = function getFilenameAndTransformationsFromCloudinaryUrl(url) {
  var regexp = /upload\/((?:(?:[^/]+,)?(?:c_crop|a_|ar_)[^/]*\/){0,4})(.+\.[^.]+)$/;
  var match = url.match(regexp);
  if (!match) {
    return {};
  }
  var _match = _slicedToArray(match, 3),
    transformations = _match[1],
    filename = _match[2];
  return {
    transformations: transformations,
    filename: filename
  };
};
var getCloudFromCloudinaryUrl = function getCloudFromCloudinaryUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var match = url.match(/.com\/(.*?)\//);
  return match && match[1];
};
var getIdFromCloudinaryVideoUrl = exports.getIdFromCloudinaryVideoUrl = function getIdFromCloudinaryVideoUrl(url) {
  var splitted = url.split('/');
  var indexOfUpload = splitted.indexOf('upload');
  var urlElementsAfterUploadAndVersion = splitted.slice(indexOfUpload + 2, splitted.length);
  var nameAndExtension = urlElementsAfterUploadAndVersion.join('/');
  var split = nameAndExtension.split('.');
  return split[0];
};
var getOptionsAsString = function getOptionsAsString(options) {
  return options.length > 0 ? "".concat(options.join(','), "/") : '';
};
var generateOptionString = exports.generateOptionString = function generateOptionString(option) {
  if (!option) {
    return [];
  }
  var shortParams = {
    angle: 'a',
    aspect_ratio: 'ar',
    background: 'b',
    border: 'bo',
    crop: 'c',
    color: 'co',
    dpr: 'dpr',
    effect: 'e',
    flags: 'l',
    height: 'h',
    keyframe_interval: 'ki',
    overlay: 'l',
    opacity: 'o',
    quality: 'q',
    radius: 'r',
    named_transformation: 't',
    underlay: 'u',
    width: 'w',
    x: 'x',
    y: 'y',
    zoom: 'z',
    audio_codec: 'ac',
    audio_frequency: 'af',
    bit_rate: 'br',
    color_space: 'cs',
    default_image: 'd',
    delay: 'dl',
    density: 'dn',
    duration: 'du',
    end_offset: 'eo',
    fetch_format: 'f',
    gravity: 'g',
    page: 'pg',
    prefix: 'p',
    start_offset: 'so',
    streaming_profile: 'sp',
    video_codec: 'vc',
    video_sampling: 'vs'
  };
  return (0, _map["default"])(option, function (value, key) {
    if (shortParams[key]) return shortParams[key] + '_' + value;else return key + '_' + value;
  });
};
var getCloudinaryImageUrl = exports.getCloudinaryImageUrl = function getCloudinaryImageUrl(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!url) {
    return null;
  }
  var _getFilenameAndTransf = getFilenameAndTransformationsFromCloudinaryUrl(url),
    transformations = _getFilenameAndTransf.transformations,
    filename = _getFilenameAndTransf.filename;
  var cloud = getCloudFromCloudinaryUrl(url);
  var localisedCloudinaryCdnHostName = (0, _cloudinaryUtils.getCloudinaryCdnHostName)();
  var optionsString = getOptionsAsString(options);
  var path = "/".concat(cloud, "/image/upload/").concat(transformations).concat(optionsString).concat(filename);
  var cloudinaryImageUrl = "https://".concat(localisedCloudinaryCdnHostName).concat(path);
  return cloudinaryImageUrl;
};
var getCloudinaryVideoUrl = exports.getCloudinaryVideoUrl = function getCloudinaryVideoUrl(url, fileType) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['ac_none'];
  if (!url) {
    return null;
  }
  if (_mediaConfig.DIRTY_VIDEO_EXTENSIONS.includes(fileType)) {
    fileType = 'mp4';
  }
  var id = getIdFromCloudinaryVideoUrl(url);
  var cloud = getCloudFromCloudinaryUrl(url);
  var localisedCloudinaryCdnHostName = (0, _cloudinaryUtils.getCloudinaryCdnHostName)();
  var optionsString = getOptionsAsString(options);
  var path = "/".concat(cloud, "/video/upload/").concat(optionsString).concat(id, ".").concat(fileType);
  return "https://".concat(localisedCloudinaryCdnHostName).concat(path);
};
var getInnerWidth = exports.getInnerWidth = function getInnerWidth() {
  return window.innerWidth;
};
var isGif = exports.isGif = function isGif(url) {
  return Boolean(url) && getExtensionFromUrl(url) === 'gif';
};
var removeSvgProperties = ['fill'];
var removeSvgStyles = ['fill'];
var removeSvgColors = exports.removeSvgColors = function removeSvgColors(svgContent) {
  var parser = new DOMParser();
  var parsedHtml = parser.parseFromString(svgContent, 'text/html');

  //remove attributes
  (0, _forEach["default"])(removeSvgProperties, function (namespace) {
    var elements = parsedHtml.getElementsByTagName('*');
    (0, _forEach["default"])(elements, function (elem) {
      (0, _forEach["default"])(elem.attributes, function (value, attr) {
        if (value.nodeName.match(namespace)) {
          elem.removeAttribute(value.nodeName);
        }
      });
    });
  });

  //remove style properties
  (0, _forEach["default"])(removeSvgStyles, function (namespace) {
    var elements = parsedHtml.getElementsByTagName('*');
    (0, _forEach["default"])(elements, function (elem) {
      if (elem.hasAttribute('style')) {
        var style = elem.getAttribute('style');
        var styleArr = style.split(';');
        var res = styleArr.filter(function (value) {
          return !value.includes(namespace);
        });
        style = res.join(';');
        elem.setAttribute('style', style);
      }
    });
  });
  return parsedHtml.getElementsByTagName('svg')[0].outerHTML;
};
//# sourceMappingURL=media-utils.js.map